function MapLayerUjjain() {
  return (
    <div>
      <div style={{ width: "100%", height: "100%" }}>
        <iframe
          src="/Simahasth.html" // your HTML file in public folder
          title="MP Garud KML Map"
          width="100%"
          height="800px"
          style={{ border: "none" }}
        />
      </div>
    </div>
  );
}

export default MapLayerUjjain;